module.exports = {
	"referendum": {
		"senato": {
			"ruolo_e_funzioni": {
				"claim": "Il ruolo e le funzioni del Senato, come previsto dalla Riforma, rendono i senatori non più \"rappresentanti della nazione\" ma \"rappresentanti di comuni e regioni\"",
				"connector": "in_che_modo",
				"reasons": [
					{
						"claim": "Il nuovo Senato ha il compito di curare il raccordo tra Stato e Regioni/comuni/città metropolitane, e di partecipare al raccordo con l’Unione Europea",
						"connector": "in_che_modo",
						"reasons": [
							{
								"claim": "Il nuovo Senato partecipa alla formazione e all'attuazione di atti e politiche UE"
							},
							{
								"claim": "Il nuovo Senato valuta le politiche pubbliche"
							},
							{
								"claim": "Il nuovo Senato fornisce pareri sulle nomine del governo"
							},
							{
								"claim": "Il nuovo Senato verifica l'attuazione leggi"
							},
							{
								"claim": "Il nuovo Senato non dà più la fiducia al Governo"
							},
							{
								"claim": "Il nuovo Senato deve dare il parere nei casi in cui il Governo vuole sostituirsi agli organi territoriali (a causa di inampienze/pericoli/ecc), salvo i casi di urgenza"
							}
						]
					}
				]
			},
			"ruolo_e_funzioni_SI": {
				"claim": "SI, è giusto modificare ruolo e funzioni del Senato",
				"connector": "o",
				"objections": [
					{
						"type": "to_claim",
						"objected_claim": "SI, è giusto modificare ruolo e funzioni del Senato",
						"theorem": {
							"claim": "NO, non è giusto modificare ruolo e funzioni del Senato"
						}
					},
					{
						"type": "to_reason / logical",
						"objected_claim": "perché se viene eletto diversamente dalla Camera è giusto che abbia funzioni diverse",
						"theorem": {
							"claim": "non è un buon motivo per eleggerlo diversamente, è solo un motivo per dargli diverse funzioni nel caso in cui venga eletto diversamente"
						}
					}
				],
				"reasons": [
					{
						"claim": "per ragioni storiche",
						"connector": "o",
						"reasons": [
							{
								"claim": "perché era previsto anche dalla riforma del Titolo V del 2001"
							},
							{
								"claim": "perché non è come i Costituenti avrebbero voluto",
								"connector": "o",
								"reasons": [
									{
										"claim": "Il Senato voluto dai nostri costituenti doveva essere rappresentativo delle Regioni ed essere molto diverso dalla Camera, per durata in carica e sistema elettorale. Ma poi, per una scelta delle maggioranze di governo, l'istituzione delle regioni venne ritardata di 22 anni, e con una riforma costituzionale venne stabilita la perfetta parità delle due Camere"
									}
								]
							}
						]
					},
					{
						"claim": "perché giustamente coinvolge stabilmente le regioni",
						"connector": "e",
						"reasons": [
							{
								"claim": "perché coinvolge stabilmente le regioni"
							},
							{
								"claim": "coinvolgere stabilmente le regioni è buono",
								"connector": "o",
								"reasons": [
									{
										"claim": "coinvolgere stabilmente le regioni riduce le conflittualità e i ritardi nelle discussioni delle leggi",
										"connector": "o",
										"reasons": [
											{
												"claim": "le regioni devono poter decidere quali siano gli interessi in gioco prima che le leggi entrino in vigore"
											},
											{
												"claim": "l'intervento delle regioni prima dell'entrata in vigore delle leggi riduce il ricorso alla Corte Costituzionale"
											}
										]
									},
									{
										"claim": "coinvolgere stabilmente le regioni aumenta il tasso di democraticità del nostro sistema"
									}
								]
							}
						]
					},
					{
						"claim": "perché se viene eletto diversamente dalla Camera è giusto che abbia funzioni diverse"
					},
					{
						"claim": "perché è in linea con altre esperienze di Paesi europei che in generale hanno funzionato bene",
						"connector": "e",
						"reasons": [
							{
								"claim": "è in linea con le esperienze di altri Paesi europei",
								"connector": "o",
								"reasons": [
									{
										"claim": "in Europa, tutti i Senati rappresentativi delle autonomie non danno la fiducia al Governo e partecipano alla legislazione solo sulle questioni più importanti, mentre svolgono funzioni di controllo connesse con il fatto che i Senatori rappresentano le autonomie"
									}
								]
							},
							{
								"claim": "questi altri Paesi europei in generale hanno funzionato bene"
							}
						]
					},
					{
						"claim": "perché il nuovo rapporto fiduciario supera i problemi derivanti da due sistemi elettorali diversi",
						"connector": "o",
						"reasons": [
							{
								"claim": "per quanto riguarda l'Italicum, tutte le maggioranze qualificate restano o sono rafforzate",
								"connector": "o",
								"reasons": [
									{
										"claim": "il premio di maggioranza, da solo, non permette ad un'unica forza politica di eleggere le più alte cariche dello Stato e degli organi di giustizia"
									}
								]
							},
							{
								"claim": "una forza politica sola deve fare comunque i conti con possibili dissensi interni, pur contando su 340 seggi"
							}
						]
					}
				]
			},
			"ruolo_e_funzioni_NO": {
				"claim": "NO, non è giusto modificare ruolo e funzioni del Senato",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché elimina un contro-potere politico esterno alla Camera senza compensare tale svuotamento",
						"connector": "e",
						"reasons": [
							{
								"claim": "elimina un contro-potere politico esterno alla Camera"
							},
							{
								"claim": "non compensa tale svuotamento con il rafforzamento del sindacato ispettivo"
							}
						]
					},
					{
						"claim": "perché ci allontana da tutti gli altri esempi nel mondo",
						"connector": "o",
						"reasons": [
							{
								"claim": "la Germania ha un ordinamento federale e ogni regione costituisce uno Stato sovrano. Sono i governi delle regioni a nominare direttamente i propri senatori (da 3 a 6 a seconda della popolazione), i quali sono sottoposti a vincolo di mandato e devono votare uniformemente alle decisioni prese dalla regione. Inoltre, il Bundesrat ha potere di veto su tutta la legislazione che riguarda le competenze regionali, con enormi capacità di interdizione"
							},
							{
								"claim": "in Francia si eleggono prima 150mila \"grandi elettori\" che, a loro volta, eleggono i senatori. Inoltre, a differenza del nuovo Senato italiano, i mandati parlamentari non si possono sovrapporre a incarichi di governo a livello regionale o locale"
							},
							{
								"claim": "nel Regno Unito, la Camera dei Lord (non elettiva) non rappresenta le istituzioni territoriali. La sua funzione è piuttosto quella di apportare modifiche di carattere tecnico alle leggi e di garantire una maggiore ponderazione delle scelte legislative, soprattutto in presenza di contrasti sociali e dissensi particolarmente forti nella società"
							},
							{
								"claim": "il Senato degli Usa, composto da un totale di 100 senatori, ha una funzione di contrappeso a garanzia della divisione dei poteri. Tutti gli elettori degli Stati membri della Federazione eleggono 2 senatori, in elezioni separate da quelle presidenziali che si svolgono ogni due anni. Il procedimento legislativo, negli Stati Uniti, è improntato ad una forma di bicameralismo paritario"
							}
						]
					},
					{
						"claim": "perché concentra nella sola Camera la fiducia al Governo, e ciò è controproducente",
						"connector": "e",
						"reasons": [
							{
								"claim": "con la nuova legge elettorale, un solo partito potrà formare il Governo e ottenere la fiducia alla Camera, anche se espressione di una esigua minoranza di votanti"
							},
							{
								"claim": "la fiducia data dalla sola Camera è controproducente",
								"connector": "e",
								"reasons": [
									{
										"claim": "non contribuisce alla stabilità",
										"connector": "o",
										"reasons": [
											{
												"claim": "nella storia repubblicana  il diniego della fiducia ha fatto cadere soltanto due governi (i due governi Prodi)"
											}
										]
									},
									{
										"claim": "non contribuisce alla governabilità",
										"connector": "e",
										"reasons": [
											{
												"claim": "la governabilità non dipende dal numero delle camere ma dalla coesione della maggioranza"
											},
											{
												"claim": "una maggioranza composita e frammentata non potrà mai produrre governabilità"
											}
										]
									}
								]
							}
						]
					},
					{
						"claim": "perché il ruolo del senato è confuso",
						"connector": "e",
						"reasons": [
							{
								"claim": "rappresenta gli enti territoriali ma ha anche altre funzioni non omogenee",
								"connector": "o",
								"reasons": [
									{
										"claim": "il nuovo Senato, pur diventando un organo di rappresentanza territoriale, continuerebbe ad esercitare funzioni tipiche di un organo dello Stato, quali l'esercizio della potestà di revisione costituzionale, le funzioni di raccordo tra Stato ed Unione Europea e tutte le altre funzioni previste dal quarto comma del nuovo art. 55"
									}
								]
							},
							{
								"claim": "obbliga i senatori a esercitare anche le funzioni di consigliere regionale o di sindaco; come faranno a svolgere entrambi gli incarachi? I senatori saranno di meno, ma il Senato non funzionerà"
							}
						]
					}
				]
			},
			"modalità_di_elezione": {
				"claim": "Viene modificata la modalità di elezione dei senatori",
				"connector": "in_che_modo",
				"reasons": [
					{
						"claim": "si riduce il numero di senatori",
						"connector": "in_che_modo",
						"reasons": [
							{
								"claim": "i senatori passano da 315 (di cui 6 dalla circoscrizione estero, più eventuali senatori a vita) a 95 (più eventuali senatori a vita e un massimo di 5 senatori a nomina presidenziale; la circoscrizione estero non elegge più dei senatori)"
							},
							{
								"claim": "il numero senatori per regione rimane fissato in proporzione alla loro popolazione (relativa all'ultimo censimento). Viene però abbassato il numero minimo di senatori per regione, che passa da 7 a 2. Anche la Val d'Aosta (che prima aveva un solo senatore) e le Province autonome di Trento e di Bolzano avranno 2 senatori"
							}
						]
					},
					{
						"claim": "si modifica la durata del mandato",
						"connector": "in_che_modo",
						"reasons": [
							{
								"claim": "il mandato di ciascun senatore è strettamente legato all'organo da cui viene eletto: nel momento in cui un senatore decade da consigliere/sindaco (per scioglimento del Consiglio territoriale, per dimissioni, o per qualunque altro motivo), esso decade anche da senatore"
							},
							{
								"claim": "i senatori nominati dal Presidente della Repubblica (massimo 5) restano in carica per 7 anni (non necessariamente coincidenti col mandato del Presidente che li ha nominati)"
							},
							{
								"claim": "il titolo di senatore a vita rimane esclusivamente per gli ex-Presidenti della Repubblica"
							}
						]
					},
					{
						"claim": "si modifica il modo in cui vengono eletti i senatori",
						"connector": "in_che_modo",
						"reasons": [
							{
								"claim": "i senatori sono eletti dai consigli regionali (a Bolzano e Trento, dai consigli provinciali) con metodo proporzionale, scegliendo tra consiglieri e sindaci. Avendo un minimo di 2 senatori da eleggere, ciascun consiglio eleggerà almeno un sindaco e almeno un consigliere. Le modalità dettagliate dell'elezione dovranno essere definite in una futura legge elettorale"
							}
						]
					}
				]
			},
			"modalità_di_elezione_SI": {
				"claim": "SI, è giusto modificare la modalità di elezione dei senatori",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché viene diminuito il loro numero",
						"connector": "o",
						"reasons": [
							{
								"claim": "per la diversa rappresentanza delle camere",
								"connector": "e",
								"reasons": [
									{
										"claim": "mentre i componenti della Camera continueranno a rappresentare l'intera Nazione, quelli del Senato rappresenteranno le istituzioni territoriali e proverranno, per la quasi totalità, dalle Regioni e dai Comuni"
									},
									{
										"claim": "vi è la necessità di assicurare che il rapporto numerico tra deputati e senatori risulti coerente con la specifica posizione che nell'ordinamento costituzionale sarà assunto dal Senato in quanto luogo di rappresentanza delle istituzioni territoriali"
									}
								]
							},
							{
								"claim": "perché riduce i costi, come parte di uno sforzo complessivo",
								"claim_objections": [
									{
										"claim": "La riduzione dei costi è risibile"
									}
								]
							}
						]
					},
					{
						"claim": "perché è giusto che il Presidente continui a nominare alcuni senatori",
						"connector": "o",
						"reasons": [
							{
								"claim": "si tratta di un elemento di tradizione, aggiornata, che finora ha dato contributi molto qualificati alla vita parlamentare"
							}
						]
					},
					{
						"claim": "perché il mandato di ciascun senatore è strettamente legato all'organo da cui viene eletto"
					},
					{
						"claim": "perché i senatori sono eletti dai consigli regionali (a Bolzano e Trento, dai consigli provinciali) con metodo proporzionale, scegliendo tra consiglieri e sindaci. Avendo un minimo di 2 senatori da eleggere, ciascun consiglio eleggerà almeno un sindaco e almeno un consigliere"
					}
				]
			},
			"modalità_di_elezione_NO": {
				"claim": "NO, non è giusto modificare la modalità di elezione dei senatori",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché si creerebbe un grande squilibrio tra le due camere",
						"connector": "e",
						"reasons": [
							{
								"claim": "la riforma sottodimensiona irrazionalmente la composizione del Senato (100 senatori) rispetto alla composizione della Camera dei deputati (630 deputati)"
							},
							{
								"claim": "rende praticamente irrilevante il voto dei senatori nelle riunioni del Parlamento in seduta comune"
							}
						]
					},
					{
						"claim": "perché la riduzione dei costi è risibile e non necessariamente buona",
						"connector": "e",
						"reasons": [
							{
								"claim": "il risparmio è di spiccioli",
								"connector": "o",
								"reasons": [
									{
										"claim": "La gran parte dei costi viene non dalle indennità, ma dalla gestione degli immobili, dai servizi, dal personale"
									},
									{
										"claim": "la Ragioneria generale dello Stato non ha mai redatto una relazione tecnica per quantificare la riduzione dei costi. Il ministro Boschi ha indicato risparmi annui per 490 milioni di euro, mentre la Presidenza del Consiglio ha detto che sono 49 milioni di euro"
									}
								]
							},
							{
								"claim": "La politica costa e risparmiare non è assultamente sinonimo di rendere migliore"
							}
						]
					},
					{
						"claim": "non ha senso che personalità che hanno illustrato la Patria per altissimi meriti vadano ad esercitare il loro magistero culturale nel senato",
						"connector": "e",
						"reasons": [
							{
								"claim": "secondo la Riforma il Senato rappresenta le istituzioni territoriali"
							},
							{
								"claim": "sarebbe più logico prevedere questo pubblico riconoscimento nell’ambito della Camera dei deputati",
								"connector": "o",
								"reasons": [
									{
										"claim": "secondo la Riforma, la Camera è l'unica a mantenere le funzioni di rappresentanza generale del popolo italiano"
									}
								]
							}
						]
					},
					{
						"claim": "perché non è capzioso immaginare che i senatori a vita possano subire l'influenza del Capo dello Stato, con conseguente attenuazione della autonomia istituzionale",
						"connector": "o",
						"reasons": [
							{
								"claim": "i senatori a nomina presidenziale sono in carica per sette anni, e cioè per un tempo perfettamente coincidente con la durata in carica dello stesso Capo dello Stato"
							}
						]
					},
					{
						"claim": "perché il modo in cui sono eletti i senatori tra i consigli regionali non è per nulla giusto",
						"connector": "o",
						"reasons": [
							{
								"claim": "il nuovo Senato non avrà una vera rappresentanza territoriale delle Regioni",
								"connector": "o",
								"reasons": [
									{
										"claim": "le Regioni avranno un numero diverso di seggi a seconda della popolazione e perché ai senatori è garantito il divieto del mandato imperativo; la natura della rappresentanza del Senato continuerà quindi ad essere quella squisitamente \"politico-partitica\", praticamente duplicando le contrapposizioni politiche della Camera dei deputati"
									}
								]
							},
							{
								"claim": "vìola la sovranità popolare",
								"connector": "o",
								"reasons": [
									{
										"claim": "non è vero che il popolo italiano eleggerebbe indirettamente il Senato perché i consigli regionali, eletti dal popolo, eleggerebbero a loro volta i senatori",
										"connector": "o",
										"reasons": [
											{
												"claim": "Leopoldo Elia (autorevolissimo costituzionalista spesso ricordato dallo stesso ex Presidente Napolitano), precisò, in maniera definitiva, che si ha elezione indiretta \"in senso proprio\" solo quando siano previsti a tal fine dei \"grandi elettori\""
											}
										]
									},
									{
										"claim": "\"la volontà dei cittadini espressa attraverso il voto [..] costituisce il principale strumento di manifestazione\", come affermato dalla Corte Costituzionale nella sentenza n. 1 del 2014"
									},
									{
										"claim": "come scrisse nel 1948 Carlo Esposito, uno dei massimi costituzionalisti italiani dello scorso secolo: \"Il contenuto della democrazia non è che il popolo costituisca la fonte storica o ideale del potere, ma che abbia il potere; non già che esso abbia solo il potere costituente, ma che a lui spettino i poteri costituiti; e che non abbia la nuda sovranità (che praticamente non è niente) ma l’esercizio della sovranità (che praticamente è tutto)\""
									}
								]
							},
							{
								"claim": "la modalità di scelta dei Senatori è rimasta del tutto indeterminata e rinviata ad una successiva legge ordinaria"
							},
							{
								"claim": "considerando che a dieci regioni e province (Valle D’Aosta, Bolzano, Trento, Friuli Venezia Giulia, Liguria, Umbria, Marche, Abruzzo, Molise, Basilicata) spettano solo due seggi, che a due (Calabria e Sardegna) ne spettano solo tre, e che uno dei seggi sempre riservato ad un sindaco, non si può affermare di voler \"rispettare la volontà degli elettori\" quando il consiglio elegge solamente uno o due consiglieri-senatore"
							}
						]
					}
				]
			},
			"il_procedimento_legislativo": {
				"claim": "Il procedimento legislativo viene sostanzialmente sdoppiato: alcune materie restano di competenza bicamerale paritaria, le altre diventano di competenza principale della Camera",
				"connector": "in_che_modo",
				"reasons": [
					{
						"claim": "sono materie bicamerali: leggi costituzionali; leggi di attuazione della costituzione su certe materie indicate; leggi riguardanti l’ordinamento degli enti locali; leggi di principio sulle associazioni fra comuni; leggi sulla partecipazione a formare/attuare diritto UE; leggi su prerogative senatori; legge elettorale del Senato; leggi di ratifica di trattati UE; leggi di attuazione del titolo V (regioni, enti locali)",
						"reasons": [
							{
								"claim": "su queste materie, il procedimento resta identico a quello odierno: una delle due Camere inizia l'esame della legge ed entrambe le Camere devono approvarla nello stesso medesimo testo"
							}
						]
					},
					{
						"claim": "sono a prevalenza della Camera dei Deputati tutte le materie non esplicitate tra quelle bicamerali e varia leggermente a seconda del tipo di legge. In generale, vale il seguente principio: le leggi vengono esaminate prima dalla Camera; se la Camera approva, il Senato ha 10 giorni di tempo per chiedere l'esame della legge e, di conseguenza, ha 30 giorni per proporre delle modifiche (la richiesta di esame da parte del Senato deve pervenire da almeno 1/3 dei senatori). Se delle modifiche vengono effettivamente proposte, queste vengono prese in esame dalla Camera, la quale si pronuncia in via definitiva. Tale procedimento può subire modifiche",
						"connector": "in_che_modo",
						"reasons": [
							{
								"claim": "nei casi di leggi di bilancio e di stabilità, la trasmissione della legge al Senato è automatica, ma il Senato ha 15 giorni (non 30) per decidere le eventuali modifiche"
							},
							{
								"claim": "nei casi di leggi approvate dalla Camera in ragione della \"clausola di supremazia\" introdotta da questa stessa riforma, la trasmissione delle legge al Senato è automatica; inoltre, qualora le modifiche proposte dal Senato vengano approvate a maggioranza assoluta, anche la Camera deve allora esprimersi a maggioranza assoluta"
							}
						]
					},
					{
						"claim": "la conversione di decreti-legge su materie bicamerali rimane a procedimento bicamerale (ossia quello descritto sopra in \"materie bicamerali\"). Nel caso di materie a prevalenza Camera, il procedimento ricalca a grandi linee quello monocamerale (ossia quello descritto sopra in \"materie a prevalenza della Camera dei Deputati\"), ma con alcune sostanziali variazioni, principalmente dovute al fatto che un decreto-legge \"muore\" se non viene convertito entro 60 giorni",
						"connector": "in_che_modo",
						"reasons": [
							{
								"claim": "da quando la Camera inizia l'esame del disegno di conversione, essa ha 40 giorni di tempo per trasmetterlo al Senato"
							},
							{
								"claim": "da quando la Camera inizia l'esame del disegno di conversione, il Senato ha 30 giorni di tempo per iniziarne anch'esso l'esame"
							},
							{
								"claim": "da quando la Camera trasmette il disegno di conversione al Senato, quest'ultimo ha 10 giorni di tempo per proporre le modifiche. In questo modo, la Camera riceverà le (eventuali) modifiche del Senato entro il 50° giorno; rimango così 10 giorni (almeno) di tempo per valutarle e approvare il disegno di conversione entro il 60° giorno"
							}
						]
					},
					{
						"claim": "il Senato può sottoporre alla Camera delle proposte di legge, ma solo se queste provengono dalla maggioranza assoluta dei senatori (i quali non possono fare individualmente delle proposte di legge, a differenza dei deputati). Su tali proposte di legge, la Camera ha il dovere di pronunciarsi in un tempo massimo di sei mesi"
					}
				]
			},
			"il_procedimento_legislativo_SI": {
				"claim": "SI, è giusto modificare il procedimento legislativo",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché rende il procedimento più funzionale, dimenuendo i tempi",
						"connector": "o",
						"reasons": [
							{
								"claim": "il superamento del bicameralismo perfetto permette di accrescere la funzionalità delle istituzioni e di cessare di essere un'eccezione mondiale"
							},
							{
								"claim": "le leggi non dovranno più pendolare tra Camera e Senato, nella speranza che alla fine si arrivi ad un testo condiviso sin nelle virgole"
							}
						]
					},
					{
						"claim": "perché non produce una maggiore complessità ma una migliore suddivisione delle tempistiche",
						"connector": "o",
						"reasons": [
							{
								"claim": "le complicazioni del procedimento legislativo restano in linea con i procedimenti legislativi degli altri Stati con parlamento bicamerale",
								"connector": "o",
								"reasons": [
									{
										"claim": "la riforma prevede, dopo l'approvazione da parte della Camera, una tempistica precisa per ogni tipologia di procedimento legislativo, con termini massimi che non potranno essere derogati"
									}
								]
							},
							{
								"claim": "la pluralità dei procedimenti legislativi non è una novità dovuta alla riforma ma è già presente nell'ordinamento",
								"connector": "o",
								"reasons": [
									{
										"claim": "oltre al procedimento legislativo ordinario ci sono già anche il procedimento abbreviato, quello decentrato, quello redigente, quello per le leggi di bilancio, quello per le leggi di conversione dei decreti-legge e quello per l'approvazione delle leggi di amnistia ed indulto"
									}
								]
							},
							{
								"claim": "la presunta scarsa chiarezza dei poteri del nuovo Senato non complica il procedimento di formazione delle leggi",
								"connector": "o",
								"reasons": [
									{
										"claim": "a parte poche specifiche materie che restano bicamerali, il Senato può occuparsi di tutte le leggi, su cui la Camera avrà l'ultima parola"
									}
								]
							}
						]
					},
					{
						"claim": "perché eventuali colpi di mano della maggioranza possono essere impediti dal Senato",
						"connector": "e",
						"reasons": [
							{
								"claim": "il Senato può richiamare tutte le leggi (ma lasciando comunque alla Camera l'ultima parola)"
							},
							{
								"claim": "il numero di senatori che può attivare l'iter del Senato è tale da garantire alle minoranze di poterlo fare"
							}
						]
					}
				]
			},
			"il_procedimento_legislativo_NO": {
				"claim": "NO, non è giusto modificare il procedimento legislativo",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché è reso più confuso, eliminando garanzie",
						"connector": "o",
						"reasons": [
							{
								"claim": "le navette prolungate con reiterati passaggi tra le due camere sono un sintomo di difficoltà politiche nella maggioranza, che si manifesterebbero anche con una sola camera decidente"
							},
							{
								"claim": "non è vero che le leggi prodotte con il sistema attuale sono poche",
								"connector": "o",
								"reasons": [
									{
										"claim": " i dati relativi al periodo 1997-2011 dicono che, in Italia, sono state approvate 1894; nello stesso periodo, sono state 2153 in Germania, 1385 in Francia, 700 in Spagna, 630 nel Regno Unito"
									}
								]
							},
							{
								"claim": "la doppia lettura costituisce una garanzia per le leggi che riguardano i diritti fondamentali dei cittadini",
								"connector": "o",
								"reasons": [
									{
										"claim": "nell'attuale congiuntura politica, l'ascolto delle istanze altrui viene vissuto come fastidio e perdita di tempo: ciò forse rende più veloce il processo, ma non certo migliori le leggi",
										"connector": "o",
										"reasons": [
											{
												"claim": "la legge dovrebbe durare oltre lo spazio di una legislatura e dovrebbe comporre e tenere presenti gli interessi di tutti: soltanto attraverso un attento confronto tra le diverse parti sociali e politiche, nella sede naturale del Parlamento, la legge — meglio ponderata — diviene espressione della sovranità popolare"
											}
										]
									}
								]
							}
						]
					},
					{
						"claim": "perché non è una semplificazione",
						"connector": "o",
						"reasons": [
							{
								"claim": "la riforma sostituisce gli articoli 70 e 72 (198 parole) con 870 parole che complicano l'iter di formazione delle leggi",
								"connector": "o",
								"reasons": [
									{
										"claim": "quadruplicare il numero di parole che regolamentano l'iter di formazione delle leggi non può rendere l'iter più semplice ma aumenta i punti di ambiguità"
									}
								]
							},
							{
								"claim": "sono una decina le diverse modalità per l'approvazione di una legge: i Presidenti di Camera e Senato dovranno risolvere i casi controversi (ossia scegliere l'iter di formazione) e diventa forte il rischio di aumentare il contenzioso davanti alla Corte Costituzionale, a causa di possibili vizi di legittimità costituzionale di natura procedimentale"
							}
						]
					},
					{
						"claim": "per l'infuenza del senato",
						"connector": "e",
						"reasons": [
							{
								"claim": "data la composizione non elettiva del Senato, non si capisce con quale legittimazione sostanziale possa esso partecipare paritariamente su materie di grande rilievo, come ad esempio le riforme costituzionali"
							}
						]
					}
				]
			},
			"diritti_dei_senatori_e_statuto_delle_minoranze": {
				"claim": "Vengono modificati i diritti dei senatori e nasce lo \"statuto delle opposizioni\"",
				"connector": "in_che_modo",
				"reasons": [
					{
						"claim": "da un lato, l'appartenenza al Senato non dà più diritto ad un'indennità. Dall'altro, i senatori mantengono la libertà dal vincolo di mandato e le cosiddette immunità parlamentari (insindacabilità per opinioni espresse e voti dati, autorizzazione all’arresto, etc.)"
					},
					{
						"claim": "entrambe le Camere dovranno inserire, nel proprio regolamento, le garanzie dei diritti delle minoranze. Per quanto riguarda la Camera, il regolamento dovrà aggiungere anche uno statuto delle opposizioni"
					}
				]
			},
			"diritti_dei_senatori_e_statuto_delle_minoranze_SI": {
				"claim": "SI, è giusto modificare i diritti dei senatori e implementare lo statuto delle minoranze",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché si tratta di un elemento che riduce i costi, all'interno di uno sforzo complessivo",
						"connector": "o",
						"reasons": [
							{
								"claim": "i futuri senatori non percepiranno alcun emolumento"
							}
						]
					},
					{
						"claim": "perché i senatori così godranno solo delle immunità parlamentari, che li proteggono in ragione della funzione che svolgono, non in ragione di un privilegio"
					},
					{
						"claim": "perché attualmente nella costituzione non esiste lo stauto delle minoranze",
						"connector": "o",
						"reasons": [
							{
								"claim": "la riforma prescrive che i regolamenti parlamentari dovranno dettare apposite disposizioni per garantire i diritti delle minoranze parlamentari"
							},
							{
								"claim": "la riforma prescrive che nel regolamento della Camera dovrà essere contenuta un'apposita disciplina relativa allo statuto delle opposizioni"
							}
						]
					}
				]
			},
			"diritti_dei_senatori_e_statuto_delle_minoranze_NO": {
				"claim": "Non è giusto modificare i diritti dei senatori e implementare lo statuto delle minoranze",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché il risparmio è minimo",
						"connector": "o",
						"reasons": [
							{
								"claim": "la gran parte dei costi viene non dalle indennità, ma dalla gestione degli immobili, dai servizi, dal personale. Comunque anche il senatore non elettivo ha un costo per la trasferta e la permanenza a Roma, nonché per l'esercizio delle funzioni (segreteria, assistente parlamentare ecc.). Risparmi con certezza maggiori si avrebbero riducendo la Camera a 400 deputati, e il Senato a 200. Avremmo in totale 600 parlamentari, invece dei 730 che la riforma ci consegna"
							}
						]
					},
					{
						"claim": "perché non è giusto che i senatori abbiano l'immunità",
						"connector": "e",
						"reasons": [
							{
								"claim": "c'è il rischio di trasformare il Senato in un refugium peccatorum",
								"connector": "o",
								"reasons": [
									{
										"claim": "i futuri 100 senatori, ancorché senatori solo part time, godrebbero dell'immunità personale dagli arresti, dalle perquisizioni personali e domiciliari, e dai sequestri della corrispondenza"
									},
									{
										"claim": "il rischio è tale perché c'è un abnorme numero di consiglieri regionali attualmente indagati o addirittura rinviati a giudizio"
									}
								]
							},
							{
								"claim": "Le attività di indagine verrebbero scoraggiate, o quanto meno gravemente impedite, dalla difficoltà a distinguere le prerogative che riguardano funzioni di consigliere o sindaco da quelle di senatore",
								"connector": "o",
								"reasons": [
									{
										"claim": "un'inchiesta penale a loro carico può diventare molto difficile, o di fatto impossibile"
									}
								]
							}
						]
					},
					{
						"claim": "perché lo statuto delle opposizioni non sarebbe una forte garanzia",
						"connector": "o",
						"reasons": [
							{
								"claim": "grazie all'Italicum, sarà il partito di maggioranza a condizionare il destino dei diritti delle minoranze e delle opposizioni",
								"connector": "o",
								"reasons": [
									{
										"claim": "i regolamenti parlamentari devono comunque essere approvati dalla maggioranza dei componenti dell'assemblea"
									}
								]
							}
						]
					}
				]
			}
		},
		"stato-regioni": {
			"conflitti_di_competenza": {
				"claim": "Vengono abrogate e ripartite tra Stato e Regioni le materie concorrenti e viene reintrodotta la \"clausola di supremazia\"",
				"connector": "in_che_modo",
				"reasons": [
					{
						"claim": "le materie che la Costituzione dichiarava di \"legislazione concorrente\" vengono redistribuite: o sono di competenza dello Stato (ossia del Parlamento per le leggi, del Governo per i regolamenti) o delle Regioni",
						"connector": "in_che_modo",
						"reasons": [
							{
								"claim": "viene aumentato l'elenco delle materie in cui lo Stato ha competenza esclusiva; in alcuni casi, tale competenza si limita a \"disposizioni generali e comuni\""
							},
							{
								"claim": "si mantiene il riferimento al fatto che la competenza esclusiva delle Regioni riguarda \"ogni materia non espressamente riservata alla competenza esclusiva dello Stato\"; tuttavia, si aggiunge nella Costituzione un riferimento esplicito ad alcune delle principali materie di competenza esclusiva delle Regioni"
							}
						]
					},
					{
						"claim": "la clausola di supremazia prevede che il governo può intervenire su materie ad esso non riservate quando richiesto per tutelare l’unità giuridica o economica della Repubblica, o la tutela dell’interesse nazionale"
					}
				]
			},
			"conflitti_di_competenza_SI": {
				"claim": "SI, è giusto modificare i criteri per stabilire la competenza legislativa",
				"connector": "o",
				"reasons": [
					{
						"claim": "per rendere il potere più accentrato",
						"connector": "o",
						"reasons": [
							{
								"claim": "per la prima volta, non si assiste ad un aumento dei poteri del sistema regionale e locale, bensì ad una loro razionalizzazione e riconduzione a dinamiche di governo complessive del paese",
								"connector": "o",
								"reasons": [
									{
										"claim": "la soppressione della legislazione concorrente comporta di per sé una riallocazione naturale della competenza che già spettava rispettivamente allo Stato o alle Regioni: per lo Stato, quella di disciplinare i principi fondamentali; per le Regioni, quella di disciplinare le norme di dettaglio"
									},
									{
										"claim": "si riportano al centro le decisioni essenziali per il governo dell'intera collettività, e si mantengono in capo alle Regioni le scelte rilevanti per gli ambiti e gli interessi regionali"
									}
								]
							}
						]
					},
					{
						"claim": "per diminuire i contenziosi presso la Corte Costituzionale",
						"connector": "o",
						"reasons": [
							{
								"claim": "il ripartimento delle funzioni legislative tra Stato e Regioni consolida quanto la Corte costituzionale ha stabilito attraverso tantissime sentenze negli ultimi quindici anni",
								"connector": "o",
								"reasons": [
									{
										"claim": "la riforma costituzionale del 2001 aveva infatti creato molta confusione, considerando concorrenti anche materie (grandi reti di trasporto e di navigazione; ordinamento della comunicazione; produzione, trasporto e distribuzione nazionale dell'energia, ecc.) in cui sarebbe del tutto irragionevole scostarsi dai principi fissati dallo Stato",
										"connector": "o",
										"reasons": [
											{
												"claim": "tuttavia, nessuna Regione ne ha mai emanate, e la Corte ha fatto salti mortali per spiegare che la competenza è dello Stato. La riforma del 2016 sancisce tutto questo con chiarezza"
											}
										]
									}
								]
							}
						]
					},
					{
						"claim": "perché, nel dettaglio, il nuovo ripartimento delle materie sarebbe migliore",
						"connector": "o",
						"reasons": [
							{
								"claim": "verso la competenza statale vengono spostate una serie di materie che la giurisprudenza della Corte Costituzionale dell'ultimo decennio aveva già riportato al centro e una serie di materie che in passato erano troppo superficialmente state devolute alle regioni"
							},
							{
								"claim": " la riforma razionalizza l'esistente e riporta al centro competenze che naturalmente devono stare al centro e che richiedono evidentemente un intervento unitario, per permettere agli organi centrali di operare scelte omogenee sul territorio, spesso necessarie per portare avanti riforme di sistema"
							},
							{
								"claim": "in virtù della competenza residuale che resterà sempre in capo alle Regioni, a queste ultime spetterà la necessaria potestà legislativa di attuazione e di specificazione, in modo da poter declinare le scelte unitarie dello Stato in relazione alle proprie esigenze connesse alla comunità ed al territorio regionali"
							}
						]
					}
				]
			},
			"conflitti_di_competenza_NO": {
				"claim": "Non è giusto modificare i criteri per stabilire la competenza legislativa",
				"connector": "o",
				"reasons": [
					{
						"claim": "per l'esagerato accentramento del potere",
						"connector": "o",
						"reasons": [
							{
								"claim": "ci si allontana dal modello \"solidale\" di federalismo (basato sulla leale collaborazione e la \"concorrenza\" tra le funzioni), per avvicinarsi al modello \"competitivo\" (basato sulla netta separazione tra Stato e Regioni e tra Regioni)"
							},
							{
								"claim": " la riforma riduce sostanzialmente lo spazio costituzionalmente riconosciuto alle autonomie",
								"connector": "o",
								"reasons": [
									{
										"claim": "il neo-centralismo statale è negativo in un contesto di complessiva riduzione degli spazi di partecipazione democratica e di rappresentanza politica",
										"connector": "o",
										"reasons": [
											{
												"claim": "con questo modello, il governo potrà (tra le altre cose) passare sulla testa delle popolazioni locali nella gestione del territorio sotto l'etichetta di opere di interesse nazionale o simili, e ciò non è accettabile"
											}
										]
									}
								]
							}
						]
					},
					{
						"claim": "perché continueranno a esserci contenziosi presso la Corte costituzionale",
						"connector": "o",
						"reasons": [
							{
								"claim": "la soppressione della potestà concorrente in chiave di semplificazione del rapporto Stato-Regioni è pubblicità ingannevole",
								"connector": "o",
								"reasons": [
									{
										"claim": "la nuova categoria di \"disposizioni generali e comuni\" (che si applica tutta una serie di materie importanti quali la tutela della salute, le politiche sociali, l'istruzione anche universitaria, l'ordinamento scolastico, le attività culturali e sul turismo e molte altre) è difficile da distinguere dalle leggi cornice della attuale potestà concorrente"
									},
									{
										"claim": " la riforma non prevede, in favore delle Regioni, la necessaria potestà legislativa di attuazione sulle stesse materie. Questa nuova formulazione appare quindi di incerto significato, e dovrà intervenire la Corte costituzionale a chiarirne la portata"
									}
								]
							},
							{
								"claim": "la riforma dimentica di attribuire la competenza legislativa esclusiva in materia importanti quali la circolazione stradale, i lavori pubblici, l'industria, l'agricoltura, l'artigianato, l'attività mineraria, le cave, la caccia e la pesca"
							},
							{
								"claim": "si è conservato il vecchio criterio di riparto delle competenze legislative tra Stato e Regioni (il criterio delle materie) che è stato indicato dalla Corte costituzionale come un fattore di destabilizzazione",
								"connector": "o",
								"reasons": [
									{
										"claim": "non si è colta l'occasione per passare ad un criterio diverso (ad esempio quello delle funzioni) che potesse effettivamente semplificare e ridurre il contenzioso tra centro e periferia"
									}
								]
							},
							{
								"claim": "da 15 anni la Corte costituzionale interviene per stabilire il confine fra Stato e Regioni. La nuova riforma fa tornare al punto di partenza: si azzera un lavoro di 15 anni e inizieranno nuovi contenziosi"
							}
						]
					},
					{
						"claim": "perché, nel dettaglio, il ripartimento delle materie non sarebbe giusto",
						"connector": "o",
						"reasons": [
							{
								"claim": "viene profondamente sconvolta l'autonomia legislativa delle Regioni, attribuendo allo Stato centrale il potere di decidere su temi fondamentali di rilevanza territoriale come la tutela dell'ambiente, e sottraendo alle Regioni ogni possibilità di governo del territorio"
							},
							{
								"claim": "alle Regioni viene invece attribuita la potestà legislativa soltanto su 15 materie (contro le 50 del Governo) di contenuto prevalentemente organizzativo"
							}
						]
					},
					{
						"claim": "per la reintroduzione della clausola di supremazia",
						"connector": "o",
						"reasons": [
							{
								"claim": "grazie alla clausola di supremazia statale (soprannominata \"clausola-vampiro\"), la Camera dei deputati o il Governo (rispettivamente con una legge o con un decreto legge) potrebbero, senza alcun limite, intervenire in qualsiasi materia di competenza legislativa esclusiva delle Regioni \"quando lo richieda la tutela dell'unità giuridica o economica della Repubblica ovvero la tutela dell'interesse nazionale\""
							}
						]
					}
				]
			}
		},
		"altro": {
			"formulazione_e_discussione_dei_decreti_legge": {
				"claim": "Viene modificata la disciplina in merito alla discussione e alla formulazione dei decreti legge",
				"connector": "in_che_modo",
				"reasons": [
					{
						"claim": "le commissioni della Camera non possono più approvare i disegni di conversione di decreti legge senza passare dal giudizio della Camera (misura proposta per contrastare la decretazione d''urgenza). Il Governo potrà però chiedere alla Camera di discutere (e votare) un DDL entro 70-85 giorni qualora esso venga ritenuto \"essenziale per il programma di governo\""
					},
					{
						"claim": "nel caso in cui un decreto di conversione di un DL venga rinviato dal Presidente della Repubblica, il DL in merito (che, di norma, scade dopo 60 giorni se non viene effettivamente convertito) guadagna altri 30 giorni di vita (cioè scade dopo 90 giorni)"
					},
					{
						"claim": "il Governo NON può emenare DL che riguardano determinati argomenti",
						"connector": "in_che_modo",
						"reasons": [
							{
								"claim": "non possono disciplinare materie costituzionali, materie elettorali (con esclusione della disciplina dell’organizzazione del procedimento elettorale e dello svolgimento delle elezioni), delegazioni legislative, conversione di DL, autorizzazioni a ratificare trattati internazionali, approvazione di bilanci e consuntivi"
							},
							{
								"claim": "non possono reiterare disposizioni che erano già state adottate in altri DL e che non erano state convertite in legge"
							},
							{
								"claim": "non possono regolare i rapporti giuridici sorti sulla base di DL che non sono stati convertiti in legge"
							},
							{
								"claim": "non possono ripristinare l'efficacia di norme di legge (o di atti aventi forza di legge) che la Corte costituzionale ha dichiarato illegittimi per vizi non attinenti al procedimento"
							},
							{
								"claim": "devono essere presentati in maniera omogenea (corrispondente al titolo) e devono essere mantenuti tali nel processo di revisione da parte del parlamento (non si possono cioè aggiungere emendamenti estranei al titolo)"
							}
						]
					}
				]
			},
			"formulazione_e_discussione_dei_decreti_legge_SI": {
				"claim": "SI, è giusto modificare la disciplina in merito alla discussione e alla formulazione dei decreti legge",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché la riforma non attribuisce nuovi poteri legislativi al Governo, e casomai limita il ricorso ai decreti-legge, che attualmente sono una vera piaga",
						"connector": "o",
						"reasons": [
							{
								"claim": "questo perché il Governo, non avendo una \"corsia preferenziale\" in Parlamento per l’approvazione dei propri disegni di legge, ricorre ai decreti-legge anche al di fuori dei casi straordinari di necessità e di urgenza di cui parla la nostra Costituzione"
							}
						]
					},
					{
						"claim": "perché la riforma prevede che il Governo possa chiedere alla Camera di deliberare entro 70 giorni su un progetto ritenuto \"essenziale per l’attuazione del programma di governo\"",
						"connector": "o",
						"reasons": [
							{
								"claim": "in questo modo la riforma fornisce una nuova opportunità di veder approvare un progetto \"essenziale\" in tempi certi, e nello stesso tempo limita il ricorso ai decreti-legge, tornando a far rispettare quello che dice la Costituzione"
							}
						]
					},
					{
						"claim": "perché i poteri normativi del governo vengono riequilibrati per evitare l’impiego elevato che si è registrato nel corso degli ultimi anni",
						"connector": "o",
						"reasons": [
							{
								"claim": "questo intervento viene compensato dalla garanzia di avere una risposta parlamentare alle principali iniziative governative in tempi certi, con la fissazione di un periodo massimo entro cui il procedimento deve concludersi"
							}
						]
					}
				]
			},
			"formulazione_e_discussione_dei_decreti_legge_NO": {
				"claim": "NO, non è giusto modificare la disciplina in merito alla discussione e alla formulazione dei decreti legge",
				"connector": "e",
				"reasons": [
					{
						"claim": "perché la riforma amplia il potere d'iniziativa legislativa del Governo grazie al potere di imporre alla Camera dei Deputati tempi certi per l'approvazione di leggi ritenuti insindacabilmente \"importanti per il programma di governo\"",
						"connetor": "o",
						"reasons": [
							{
								"claim": "così il Governo si impadronisce di fatto dell'Agenda dei lavori parlamentari (senza nemmeno il limite dei requisiti di \"necessità e urgenza\" chiesti per i decreti legge)",
								"connector": "o",
								"reasons": [
									{
										"claim": "si rischia allora di restringere ulteriormente gli spazi per l'iniziativa legislativa parlamentare (attualmente ridotti al solo 20 per cento), grazie a possibili capziose interpretazioni estensive sia del concetto di \"programma di governo\", sia del concetto di \"attuazione del programma\""
									}
								]
							}
						]
					},
					{
						"claim": "l'esecutivo acquisisce uno strumento di ingerenza nel potere legislativo che viola il principio di separazione dei poteri, mentre la funzione del deputato viene svilita ad un \"passacarte\" incaricato di premere il tasto \"Sì\" al momento giusto"
					}
				]
			},
			"garanzie": {
				"claim": "Viene modificato il sistema delle garanzie costituzionali in materia di pregiudizio di costituzionalità sulla legge elettorale, elezione del Presidente della Repubblica, elezione dei membri della Corte costituzionale",
				"connector": "in_che_modo",
				"reasons": [
					{
						"claim": "su iniziativa di 1/4 dei deputati o di 1/3 dei senatori, può essere richiesto alla Corte Costituzionale un pre-giudizio di costituzionalità sia su una nuova legge elettorale, sia sulla legge elettorale attualmente in vigore"
					},
					{
						"claim": "per l'elezione del Presidente della Rupubblica sono necessari i 2/3 dei voti dell'assemblea nei turni 1, 2 e 3 (come prima); i 3/5 dei voti dell'assemblea nei turni 4, 5 e 6; i 3/5 dei voti dei presenti dal turno 7 in poi"
					},
					{
						"claim": "ad oggi, il Parlamento elegge i suoi 5 membri in seduta comune. Con la riforma, 3 membri verranno eletti dalla Camera e 2 dal Senato"
					}
				]
			},
			"garanzie_SI": {
				"claim": "SI, è giusto modificare il sistema delle garanzie costituzionali sopra citate",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché il ricorso diretto alla Corte sulla legge elettorale potenzia il sistema delle garanzie",
						"connector": "e",
						"reasons": [
							{
								"claim": "il numero di senatori che possono chiedere il giudizio preventivo della Corte costituzionale sulla legittimità costituzionale delle leggi elettorali è tale da garantire alle minoranze di poterlo fare"
							}
						]
					},
					{
						"claim": "perché il quorum più alto per eleggere il Presidente della Repubblica potenzia il sistema delle garanzie",
						"connector": "e",
						"reasons": [
							{
								"claim": "sono inoltre previsti tutti gli accorgimenti necessari affinché l'elezione del Presidente della Repubblica non sia espressione della sola maggioranza di governo"
							}
						]
					},
					{
						"claim": "perché il nuovo sistema di elezione dei giudici della Corte proposto dalla riforma è più logico e adeguato in relazione alla modifica apportata alle camere",
						"connector": "o",
						"reasons": [
							{
								"claim": "perché frazionando l’elezione dei cinque giudici della Corte di provenienza parlamentare tra le due Assemblee, si è voluto tenere conto del mutato rapporto numerico tra Camera e Senato"
							},
							{
								"claim": "se si fosse mantenuta l’attuale elezione da parte del Parlamento in seduta comune, infatti, i predetti cinque giudici costituzionali sarebbero stati selezionati soltanto sulla base della volontà esclusiva dei componenti della Camera"
							},
							{
								"claim": "sono previsti tutti gli accorgimenti necessari affinché l'elezione del Presidente della Repubblica non sia espressione della sola maggioranza di governo"
							},
							{
								"claim": "chi invoca un'influenza territoriale sui giudici eletti, non considera che 1) è invece un bene che i giudici costituzionali (che devono garantire anche le Regioni) siano particolarmente sensibili agli interessi dei territori, e 2) che – altrimenti – tutti e 5 i giudici di estrazione parlamentare diverrebbero oggetto di negoziato partitico con assoluta prevalenza della componente Camera dei deputati"
							}
						]
					}
				]
			},
			"garanzie_NO": {
				"claim": "NO,non è giusto modificare il sistema delle garanzie costituzionali in materia di pregiudizio di costituzionalità sulla legge elettorale, elezione del Presidente della Repubblica, elezione dei membri della Corte costituzionale",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché non è chiaro il rapporto tra questa nuova competenza (sindacato in via preventiva) e quella attualmente svolta (sindacato in via successiva): potrà una legge elettorale essere sindacata anche successivamente? E che influenza eserciterà il giudizio preventivo su quello successivo?"
					},
					{
						"claim": "perché in realtà, il giudizio preventivo di costituzionalità sulle leggi elettorali rischia di politicizzare il giudizio della Corte costituzionale",
						"connector": "o",
						"reasons": [
							{
								"claim": "esso avverrà subito dopo l'approvazione delle legge e sarà di natura generale e astratta. La stessa Corte costituzionale si era opposta a questa nuova competenza mediante una dichiarazione del Presidente della Corte"
							}
						]
					},
					{
						"claim": "l'effetto sinergico dato dalla riduzione del numero dei senatori e dal dominio sulla Camera dei deputati (assicurato dal premio di maggioranza dell'Italicum) rendono decisiva l'influenza della maggioranza di governo nell'elezione in seduta comune del Capo dello Stato",
						"connector": "o",
						"reasons": [
							{
								"claim": "inoltre, dal settimo scrutinio in poi, la maggioranza dei 3/5 è calcolata \"sui votanti\" e non \"sui componenti\". Non può escludersi dunque un Presidente eletto con maggioranze parlamentari ridotte (qualora una o più forze politiche decidano di non presentarsi al voto)"
							}
						]
					},
					{
						"claim": "perché il nuovo sistema di elezione dei giudici della Corte proposto dalla riforma permette al governo gravi ingerenze",
						"connector": "o",
						"reasons": [
							{
								"claim": "come per il Presidente della Repubblica, l'effetto sinergico dato dalla riduzione del numero dei senatori e dal dominio sulla Camera dei deputati (assicurato dal premio di maggioranza dell'Italicum) rendono decisiva l'influenza della maggioranza di governo nell'elezione di membri della Corte costituzionale o di autorità indipendenti da parte della Camera"
							}
						]
					},
					{
						"claim": "perché la riforma attribuisce al Senato, composto da 100 senatori, il potere di eleggere due giudici costituzionali ed attribuisce alla Camera dei deputati, composta invece da 630 deputati, il potere di eleggerne tre e ciò è sbagliato",
						"connector": "e",
						"reasons": [
							{
								"claim": "urta contro il principio di proporzionalità"
							},
							{
								"claim": "rischia di introdurre nella Corte costituzionale una pericolosa logica corporativa, che potrebbe fortemente irrigidire i rapporti interni tra i suoi membri",
								"connector": "o",
								"reasons": [
									{
										"claim": "si contesta il fatto che le elezioni di un organo di garanzia costituzionale avvenga da parte di un organo (il Senato) di natura territoriale"
									}
								]
							}
						]
					}
				]
			},
			"iniziativa_popolare": {
				"claim": "Vengono modificate le norme costituzionali riguardanti le proposte di legge dei cittadini, i referendum abrogativi e introdurre referendum propositivi e di indirizzo",
				"connector": "in_che_modo",
				"reasons": [
					{
						"claim": "le proposte di legge dei cittadini richiedono 150 mila firme (non più 50 mila) e viene introdotto l'obbligo di discussione in tempi, forme e limiti che dovranno essere definiti nel regolamento parlamentare"
					},
					{
						"claim": "vengono introdotti in Costituzione i referendum propositivi e di indirizzo, le cui modalità dovranno però essere definite da future leggi costituzionali (in termini di \"condizioni ed effetti\") e da future leggi bicamerali (in termini di \"modalità di attuazione\")"
					},
					{
						"claim": "ad oggi, il referendum abrogativo può essere richiesto con 500 mila firma e prevede un quorum pari a \"la metà più uno degli elettori\". Con la riforma, si introduce la seguente clausola: qualora il referendum venga richiesto con 800 mila firma, il quorum viene abbassato a \"la metà più uno degli elettori delle ultime elezioni politiche\""
					}
				]
			},
			"iniziativa_popolare_SI": {
				"claim": "SI, è giusto modificare le norme costituzionali riguardanti le proposte di legge dei cittadini, i referendum abrogativi e introdurre referendum propositivi e di indirizzo",
				"connector": "o",
				"reasons": [
					{
						"claim": "per aumentare la partecipazione diretta da parte dei cittadini",
						"connector": "o",
						"reasons": [
							{
								"claim": "con l'obbligo di discussione delle proposte di legge, l’iniziativa popolare delle leggi viene rafforzata"
							},
							{
								"claim": "vengono introdotti in Costituzione i referendum propositivi e di indirizzo, le cui modalità dovranno però essere definite da future leggi costituzionali (in termini di \"condizioni ed effetti\") e da future leggi bicamerali (in termini di \"modalità di attuazione\")"
							},
							{
								"claim": "il referendum abrogativo viene rafforzato"
							}
						]
					}
				]
			},
			"iniziativa_popolare_NO": {
				"claim": "NO, non è giusto modificare le norme costituzionali riguardanti le proposte di legge dei cittadini, i referendum abrogativi e introdurre referendum propositivi e di indirizzo",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché le firme richieste per la presentazione di una proposta di legge sono triplicate, da 50.000 a 150.000. Inoltre, le garanzie di discussione sono rinviate al regolamento, e la maggioranza parlamentare rimane libera di rigettare o modificare la proposta"
					},
					{
						"claim": "perché la riforma rinvia la disciplina dei nuovi referendum propositivi e di indirizzo ad una successiva legge costituzionale; tutto rimane da fare. L'introduzione di una disciplina incompiuta dimostra un chiaro intento di non provvedere"
					},
					{
						"claim": "perché in un tempo in cui i corpi intermedi (partiti, sindacati) sono indeboliti o sostanzialmente dissolti, il tetto di 800 mila firme per i referendum abrogativi è quasi impossibile da raggiungere. E non si capisce perché un referendum debba avere un quorum più alto se richiesto da 500.000 cittadini, e più basso se richiesto da 800.000"
					}
				]
			},
			"semplificazione_istituzionale": {
				"claim": "Sono abrogati il CNEL e le province",
				"connector": "in_che_modo",
				"reasons": [
					{
						"claim": "viene abrogato il Consiglio Nazionale dell' Economia e del Lavoro"
					},
					{
						"claim": "viene rimosso ogni riferimento alle province dalla Costituzione"
					}
				]
			},
			"semplificazione_istituzionale_NO": {
				"claim": "NO, non è giusto abrogare il CNEL e le province",
				"connector": "o",
				"reasons": [
					{
						"claim": "abrogare il CNEL è senza dubbio giusto, ma una eventuale riforma che elimini il CNEL, intervenendo soltanto su un articolo della costituzione, sarebbe approvata da tutte le forze politiche in poco tempo. In questa riforma tanto ampia rimane comunque una goccia nell'oceano, che pare quindi inserita a scopo puramente propagandistico"
					},
					{
						"claim": "eleminare i riferimenti alle province è elemento marginale; persino non necessario, come è provato dal fatto che la riforma delle province è stata già da tempo avviata. Va precisato che l'abolizione delle Province elimina la \"copertura costituzionale\", ma non produce l'effetto automatico della cancellazione di questi enti territoriali, che potranno continuare ad essere regolati dalla legge, almeno fin tanto che la maggioranza e il Governo lo riterrà utile. Difatti, ad un anno dalla legge 56 del 2014 (Delrio) che traferiva le funzioni delle Province a Regioni e Comuni, la Corte dei Conti ha disegnato un quadro piuttosto negativo: le Province continuano a fare sotanzialmente quello che facevano prima; i costi non si sono ridotti, perché il personale è stato solo trasferito. Solamente i cittadini hanno perso il potere di scegliere direttamente chi deve gestire i loro servizi ed il loro territorio"
					}
				]
			},
			"semplificazione_istituzionale_SI": {
				"claim": "SI, è giusto abrogare il CNEL e le province",
				"connector": "o",
				"reasons": [
					{
						"claim": "abrogndo il CNEL viene operata una decisa semplificazione istituzionale"
					},
					{
						"claim": "la decostituzionalizzazione delle province, insieme al resto, riduce costi non più giustificabili, restituendo credibilità alle istituzioni"
					}
				]
			}
		},
		"oltre_il_merito": {
			"riforma_storica_o_conservatrice_SI": {
				"claim": "È necessario apportare queste modifiche costituzionali che sono attese da fin troppo tempo",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché questa riforma costituzionale prende le mosse dalla necessità impellente di chiudere pagine rimaste aperte sin dall'inizio",
						"connector": "o",
						"reasons": [
							{
								"claim": "non solo la seconda parte della Costituzione non risulta più adeguata alle esigenze dell'oggi, ma si può sostenere senza timore che essa, per quanto riguarda le pagine aperte su cui ci si sta per soffermare, abbia manifestato fin da subito seri problemi",
								"connector": "o",
								"reasons": [
									{
										"claim": "la nostra costituzione è piena di \"pagine aperte\", di nodi non sciolti, di soluzioni istituzionali volutamente contraddittorie e farraginose",
										"connector": "o",
										"reasons": [
											{
												"claim": "i problemi iniziarono già dalla primavera del 1947, quando si delineò con contorni nitidi la divisione in blocchi che avrebbe caratterizzato negli anni successivi la Guerra fredda",
												"connector": "o",
												"reasons": [
													{
														"claim": "dal compromesso e l'accordo che caratterizzarono la scrittura, in particolare, della prima parte della Carta – quella, per intenderci, dedicata ai principi e ai diritti – si passò alla stagione della diffidenza reciproca e dei veti incrociati. E le soluzioni che si andarono ricercando furono studiate proprio per impedire all'avversario – meglio: quello che improvvisamente era diventato il nemico – di prevalere sino in fondo, in caso di vittoria"
													}
												]
											}
										]
									}
								]
							}
						]
					},
					{
						"claim": "perché senza questa riforma nessun dei cambiamenti proposti sarà possibile per non si sa quanti anni"
					}
				]
			},
			"riforma_storica_o_conservatrice_NO": {
				"claim": "La riforma consolida la crescente marginalizzazione del ruolo del Parlamento",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché il Parlamento come luogo di rappresentanza, di confronto e di mediazione di interessi reali è ridotto al regno della formalità procedurale",
						"connector": "o",
						"reasons": [
							{
								"claim": "da vent’anni, infatti, le Camere sono ridotte ad un ruolo marginale nel confronto politico e schiacciate dall’abuso della decretazione d’urgenza e dei maxiemendamenti, dall’uso continuo e strumentale della fiducia, dal contingentamento dei tempi di discussione e la riforma non fa che rafforzare ciò"
							}
						]
					},
					{
						"claim": "perché la riforma aumenterà lo spostamento dell’asse istituzionale a favore dell’Esecutivo",
						"connector": "e",
						"reasons": [
							{
								"claim": "la Camera a cui spetterà dare la fiducia al Governo (la Camera dei deputati) sarà priva di legittimazione popolare, perché eletta con una legge elettorale il cui unico scopo è quello di assicurare comunque una maggioranza artificiale. Ballottaggio, premio di maggioranza alla singola lista, soglie d’accesso e voto bloccato sui capilista consegnano la Camera nelle mani di un leader vincente anche con pochi voti, secondo il modello dell’uomo solo al comando"
							},
							{
								"claim": "il voto diverrà un plebiscito per il \"capo\", che potrà scegliere e disporre liberamente dei parlamentari, interessati a seguire il leader che garantirà loro la rielezione più che a farsi interpreti della volontà popolare. Un incentivo al trasformismo che negli ultimi due anni e mezzo ha già coinvolto 246 parlamentari"
							}
						]
					}
				]
			},
			"rischi_per_la_democrazia_SI": {
				"claim": "Non esiste nessun rischio per la democrazia nè i poteri sarebbero accentrati in modo eccessivo nelle mani del governo",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché la tesi del \"premierato assoluto\" o dell' \"uomo solo al comando\" è infondata",
						"connector": "o",
						"reasons": [
							{
								"claim": "la riforma non modifica nessuna disposizione costituzionale relativa al Presidente del consiglio, né in relazione alla nomina, né in ordine ai poteri, né tanto meno circa la posizione rispetto all’esercizio delle funzioni proprie del Presidente della Repubblica, che rimangono immutate"
							}
						]
					},
					{
						"claim": "perché la disciplina dell’Italicum non incide sulla posizione costituzionale del Presidente del consiglio, né sul ruolo di garanzia che spetterà sempre al Capo dello Stato, in particolare in sede di formazione del Governo e dunque nel momento della nomina del Presidente del consiglio",
						"connector": "o",
						"reasons": [
							{
								"claim": "nella legge attuale, in combinato disposto con la riforma costituzionale, nulla configura un’anomala concentrazione di poteri",
								"connector": "o",
								"reasons": [
									{
										"claim": "la maggioranza di 24 deputati alla Camera al fine di governare non consente al vincitore né di rivedere da solo la Costituzione, né di esprimere da solo la composizione degli organi di garanzia"
									},
									{
										"claim": "la riforma riduce il potere del Governo di ricorrere ai decreti legge"
									},
									{
										"claim": "chi teme l’effetto combinato della riforma costituzionale con la nuova legge elettorale, è garantito dal fatto che - grazie alla stessa riforma - l’Italicum verrà giudicato immediatamente dalla Corte costituzionale"
									}
								]
							}
						]
					}
				]
			},
			"rischi_per_la_democrazia_NO": {
				"claim": "I poteri sarebbero accentrati in modo eccessivo nelle mani del governo, tanto da creare un rischio per la nostra democrazia",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché il nostro ordinamento si orienterebbe di fatto verso un \"premierato assoluto\", grazie al combinato con l'Italicum",
						"connector": "e",
						"reasons": [
							{
								"claim": "quest'ultimo trasformerebbe il voto al partito del leader in un'investitura quasi-diretta del Premier, mentre la riforma costituzionale eliminerebbe il Senato come potenziale contro-potere esterno della Camera, senza prevedere efficaci contro-poteri interni"
							},
							{
								"claim": "il risultato è il duplice rischio, connesso all' \"uomo solo al comando\", di produrre eccessivi squilibri di rappresentanza e di condizionare addirittura i poteri del Presidente della Repubblica"
							}
						]
					},
					{
						"claim": "perché la riforma è solo il culmine di un processo di indebolimento del Parlamento rappresentativo in corso da anni, un processo che ha consegnato di fatto al Governo il potere di fare le leggi",
						"connector": "e",
						"reasons": [
							{
								"claim": "l'Esecutivo ha abusato del potere di fare decreti legge in casi di \"urgenza\" e di porre la fiducia sui provvedimenti all'esame del Parlamento - compresa la legge elettorale - abituando i cittadini alla logica del ricatto"
							},
							{
								"claim": "l'esercizio della funzione legislativa gli è stato delegato con vincoli sempre meno stringenti"
							}
						]
					}
				]
			},
			"il_metodo_SI": {
				"claim": "Si tratta di una riforma con un testo omogeneo, votata da un parlamento legittimo, nonostante l'ostruzionismo eccessivo da parte delle opposizioni",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché il tema dell'omogeneità è una questione totalmente infondata",
						"connector": "o",
						"reasons": [
							{
								"claim": "quello dell'omogeneità nasce come requisito imposto dalla Corte costituzionale ai quesiti referendari abrogativi; la valutazione di omogeneità del contenuto è stata già fatta dal legislatore costituzionale, che ha ritenuto di tenere insieme alcuni precisi elementi di riforma"
							},
							{
								"claim": "in ogni caso il contenuto della riforma è omogeneo se consideriamo la forte connessione fra trasformazione del Senato in camera delle autonomie e riforma del Titolo V"
							}
						]
					},
					{
						"claim": "perché nella sentenza n. 1 del 2014, la Corte ha espressamente scritto che la illegittimità della legge elettorale non travolgeva la legittimazione giuridica (né politica) delle Camere della XVII legislatura",
						"connector": "o",
						"reasons": [
							{
								"claim": " se così fosse stato, si sarebbe dovuto sciogliere le Camere e fare elezioni sulla base di una legge elettorale scritta dalla Corte, con la certezza di una ulteriore paralisi istituzionale"
							},
							{
								"claim": "su questo ha concordato la stragrande maggioranza delle forze parlamentari, nonché il presidente della Repubblica allora in carica, oltre che il suo successore"
							},
							{
								"claim": " inoltre, in ogni caso, con la partecipazione al referendum degli stessi titolari della sovranità popolare (cioè i cittadini, proprio coloro su nome dei quali è esercitata la rappresentanza parlamentare) potranno scegliere se percorrere la via delle riforme"
							}
						]
					},
					{
						"claim": "perché il procedimento di revisione costituzionale si innesta sul procedimento legislativo ordinario, sicché non esiste alcun problema costituzionale nel fatto che il testo sia stato presentato dal Presidente del Consiglio e dal Ministro per le riforme istituzionali",
						"connector": "o",
						"reasons": [
							{
								"claim": "già in diversi altri casi, in passato, è stato proprio il Governo a iniziare il procedimento"
							},
							{
								"claim": "il principio che la revisione della Costituzione potesse aver luogo su iniziativa del Governo venne addirittura approvato nel 15 gennaio 1947 dalla II Sottocommissione dell’Assemblea costituente"
							}
						]
					},
					{
						"claim": "perché non ci sono state anomalie, anzi, in realtà, si è assistito – specie nelle fasi cruciali dell’iter – ad un ostruzionismo senza quartiere e del tutto ingiustificato",
						"connector": "o",
						"reasons": [
							{
								"claim": " è chiaro che se chi si oppone fa uso spregiudicato del regolamento per mettere i bastoni fra le ruote a chi è in maggioranza, la maggioranza, a sua volta, userà tutti gli strumenti a disposizione per battere l’ostruzionismo"
							}
						]
					}
				]
			},
			"il_metodo_NO": {
				"claim": "Si tratta di una riforma con un testo disomogeneo, votata da un parlamento illegittimo, segnata da anomalie nel mezzo dell'iter, voluta dal governo e non dal parlamento",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché la riforma non può pertanto essere considerata una \"legge di revisione\" come previsto dall'Art. 138 della Costituzione, secondo il quale il quesito sottoposto all'elettore dovrebbe essere unico ed omogeneo (come anche affermato più volte dalla Corte costituzionale)",
						"connector": "e",
						"reasons": [
							{
								"claim": "la riforma ha un contenuto disomogeneo, in quanto modifica in più parti, diverse tra loro, la Costituzione vigente"
							},
							{
								"claim": "costringe l'elettore ad esprimere, con un solo voto, la propria adesione (o il proprio dissenso) sulla totalità delle modifiche: o tutto o niente"
							}
						]
					},
					{
						"claim": "perché si registrano diverse anomalie sull'iter della riforma",
						"connector": "e",
						"reasons": [
							{
								"claim": "le interferenze del Governo sulla libertà di coscienza dei parlamentrari e su tempi e modalità di approvazione"
							},
							{
								"claim": "la rimozione degli onorevoli Mauro e Mineo dalla Commissione Affari costituzionale (luglio 2014), che avevano invocata il rispetto della libertà di coscienza"
							},
							{
								"claim": "la mancata conferma del relatore di minoranza (sen. Calderoli) nella terza lettura della riforma, con il pretesto della fine del cosiddetto \"patto del Nazareno\""
							},
							{
								"claim": "l'approvazione del cosiddetto \"canguro\" (ottobre 2015) che ha precluso la discussione di diversi emendamenti a voto segreto (i qali ponevano rischi di divisioni interne per il Governo e la maggioranza)"
							},
							{
								"claim": "i lavori in commissione, inoltre, sono stati ridotti all’osso e numerose forzature procedurali hanno impedito il normale svolgimento della discussione, in una logica complessiva che non era di confronto tra maggioranza e opposizione, ma di mera conta numerica degli schieramenti"
							}
						]
					},
					{
						"claim": "perché un Parlamento così delegittimato e composto da parlamentari \"nominati\", insicuri di essere rieletti e perciò ricattabili ed esposti alla mercé del migliore offerente, non avrebbe dovuto procedere a una revisione costituzionale di così ampia portata. Così la riforma della Costituzione è divenuta oggetto di scambio e di ascesa politica",
						"connector": "o",
						"reasons": [
							{
								"claim": "la riforma è stata approvata nonostante la Corte costituzionale, con la sentenza n. 1 del 2014, avesse dichiarato incostituzionale la legge elettorale sulla cui base la XVII legislatura era stata eletta (il cosiddetto Porcellum)"
							}
						]
					},
					{
						"claim": "perché la riforma consegue da un'iniziativa governativa e non da un'iniziativa parlamentare (come avrebbe dovuto essere); il rischio (puntualmente avveratosi) è di condizionare l'approvazione della riforma alle scelte di indirizzo politico del Governo"
					}
				]
			},
			"questioni_politiche_SI": {
				"claim": "La riforma è stata approvata in parlamento con una buona maggioranza e non c'è nessun problema con il fatto che Renzi leghi il successo del suo governo all'esito del voto",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché spetta al popolo decidere se la riforma possa essere considerata o meno la \"casa comune\" degli italiani",
						"connector": "o",
						"reasons": [
							{
								"claim": "i costituenti sono stati assai chiari sulla questione del consenso parlamentare: affinchè la Costituzione sia legittimamente modificata, occorre almeno la maggioranza assoluta nelle due ultime votazioni parlamentari, e - se non si raggiunge la maggioranza dei due terzi - è possibile ricorrere al voto popolare"
							}
						]
					},
					{
						"claim": "perché la riforma è stata approvata da una larga maggioranza (quasi 60% in ogni lettura), con il contributo delle due Camere e di vari gruppi anche di opposizione che si rivelato decisivo e rilevante"
					},
					{
						"claim": "perché il fatto che Renzi leghi il destino del Governo all'approvazione popolare è un atto di coerenza, nel momento in cui ha chiesto la fiducia al Parlamento ponendo la riforma elettorale e quella costituzionale al primo posto del suo programma politico"
					}
				]
			},
			"questioni_politiche_NO": {
				"claim": "La riforma è stata approvata in parlamento senza un largo consenso e non è giusto che Renzi leghi il successo del suo governo all'esito del voto",
				"connector": "o",
				"reasons": [
					{
						"claim": "perché la riforma è stata approvata da una maggioranza raccogliticcia e occasionale, col sostegno decisivo dei voltagabbana",
						"connector": "o",
						"reasons": [
							{
								"claim": "il risultato della sesta e ultima votazione (su 630 deputati, 361 voti favorevoli, 7 contrari e 2 astenuti) conferma la natura \"divisiva\" e non \"inclusiva\" della riforma",
								"connector": "o",
								"reasons": [
									{
										"claim": "perché il Presidente del Consiglio ha fatto sì che le modifiche costituzionali rispondessero alle scelte di indirizzo politico del Governo, a tutti i costi"
									}
								]
							}
						]
					},
					{
						"claim": "perché Renzi lega il suo futuro all'esito del voto perché teme un confronto serio sulle scelte fatte, che vada oltre le battute e i tweet",
						"connector": "e",
						"reasons": [
							{
								"claim": "con la spinta plebiscitaria Renzi vuole condizionare il voto popolare"
							},
							{
								"claim": "vuole sostenere il sì non con i ragionati argomenti di una buona riforma, ma con la minaccia dell'instabilità e della crisi che seguirebbero alla vittoria del no"
							}
						]
					}
				]
			}
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/theorems.json
 ** module id = 428
 ** module chunks = 0
 **/